export default __webpack_public_path__ + "static/about_us-fc7a717d594561d9436e1ee5b75574dd.png";